<template>
  <div class="applicant-reset-winner-dialog">
    <el-dialog custom-class="with-title" :title="displayText + '解除'" :visible.sync="visible" :show-close="!loading">
      <div v-loading="loading">
        <div class="dialog-content">
          <div class="message message-error mb-x3">
            <div>{{ displayText + 'を一括解除してよろしいですか?' }}</div>
            <div>この操作は取り消しできません。</div>
          </div>
        </div>
        <div class="input-container" v-if="isWinnerType">
          <el-switch active-text="当選連絡したユーザーを除外" :active-value="1" :inactive-value="0"></el-switch>
        </div>
        <div class="dialog-footer" slot="footer">
          <div layout layout-align="end-center">
            <el-button type="primary" @click="submit()"><i class="mdi mdi-playlist-play"></i>一括解除を実行</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script lang="ts">
import { mapActions, mapState } from 'pinia'
import { defineComponent } from 'vue'

import api from '@/client/core/api'
import { useTwitterInstantwinMessageHistoryStore } from '@/client/store/useTwitterInstantwinMessageHistoryStore'

export default defineComponent({
  data() {
    return {
      type: '',
      visible: false,
      loading: false,
      isSubmit: false
    }
  },
  computed: {
    ...mapState(useTwitterInstantwinMessageHistoryStore, {
      campaign: state => state.campaign
    }),

    displayText() {
      if (this.type === 'winner') {
        return '当選者'
      }

      return '回答者'
    },
    isWinnerType() {
      return this.type === 'winner'
    }
  },
  methods: {
    ...mapActions(useTwitterInstantwinMessageHistoryStore, ['fetchHistoryList', 'fetchCampaign']),

    /**
     * ダイアログをリセット
     */
    reset() {
      this.loading = false
      this.isSubmit = false
    },

    /**
     * フォームのサブミット
     */
    async submit() {
      if (this.isSubmit) {
        return
      }

      this.isSubmit = true
      this.loading = true
      const params = {
        campaignId: this.campaign?.id,
        type: this.type
      }

      const result = await api.post('/twitter_instantwin_applicants/resets', params)
      this.loading = false
      setTimeout(() => {
        this.isSubmit = false
      }, 2000)

      // 失敗した場合はエラーを表示
      if (!result.data) {
        this.$notify({
          title: `${this.displayText}の一括解除に失敗しました。`,
          message: '恐れ入りますが、時間を置いて再度お試しください。',
          customClass: 'danger',
          duration: 5000
        })

        return
      }

      // 成功メッセージを表示
      this.$notify({
        title: `${this.displayText}を一括解除しました。`,
        message: '',
        customClass: 'success',
        duration: 5000
      })

      this.fetchHistoryList()
      this.fetchCampaign()
      this.close()
    },

    /**
     * ダイアログを開く
     */
    open(type: string) {
      this.type = type
      this.visible = true
      this.reset()
    },

    /**
     * ダイアログを閉じる
     */
    close() {
      this.visible = false
    }
  }
})
</script>
